enum PostMessageMethod {
  ReportComponentError = 'reportRemoteComponentError',
  RemoteComponentReady = 'remoteComponentReady',
}

interface Payload {
  method: PostMessageMethod;
  value?: string;
  id: string;
}

const sendPlayerPostMessage = (payload: Payload) => {
  const targetOrigin = window?.document?.referrer ?? '*';

  if (targetOrigin) {
    window?.parent?.postMessage(payload, targetOrigin);
  }
};

export const sendPlayerError = (error: Error) => {
  sendPlayerPostMessage({
    method: PostMessageMethod.ReportComponentError,
    value: JSON.stringify(error),
    id: 'ai-widget',
  });
};

export const sendAppReady = () => {
  sendPlayerPostMessage({
    method: PostMessageMethod.RemoteComponentReady,
    id: 'ai-widget',
  });
};
